module.exports = __webpack_public_path__ + "static/media/partner_JD.60591ed7.png";